<script setup lang="ts">
import { computed } from 'vue'
import { formattedDate } from 'frontcore/presentation/calendar/domain/helpers'

type Props = {
  dataTest?: string
  label?: string
  placeholder?: string
  value?: Date | null
}
const props = withDefaults(defineProps<Props>(), {
  dataTest: 'calendar-menu-selection',
  value: null,
})

type Emits = (e: 'click', event: Event) => void
const emit = defineEmits<Emits>()

const selectedDate = computed((): string => {
  if (props.value == null) { return props.placeholder ?? ''}
  return formattedDate(props.value) ?? ''
})

const labelDataTest = computed(():string => `${props.dataTest}-label`)
const dateDataTest = computed(():string => `${props.dataTest}-date`)
const dateCSSClass = computed((): string => {
  return props.value != null ? 'text-core-primary-10' : 'text-core-neutral-cold-60'
})
</script>

<template>
  <div 
    :data-test="dataTest"
    class="calendar__menu__selection flex flex-column s-p-2 gap-1"
    @click.stop="emit('click', $event)">
    <span
      :data-test="labelDataTest"
      class="body--auxiliary-01-bold text-core-primary-10">
      {{ label }}
    </span>
    <span
      :data-test="dateDataTest"
      :class="dateCSSClass"
      class="calendar__menu__selection_date body--auxiliary-01">
      {{ selectedDate }}
    </span>
  </div>
</template>

<style scoped>
.calendar__menu__selection {
  border: 1px solid var(--core-neutral-cold-80);
  border-radius: 4px;
  text-transform: capitalize;
}

.calendar__menu__selection.selected, .calendar__menu__selection:focus {
  background-color: var(--core-primary-99);
  border: 1px solid var(--core-primary-50);
}

.calendar__menu__selection:hover {
  background-color: var(--core-primary-95);
  border: 1px solid var(--core-neutral-cold-80);
}
</style>
